(function () {
  function setupContainer(container) {
    var sidebar = container.querySelector('[data-blog-post-inserts-sidebar]');
    var inserts = Array.prototype.slice.call(
      container.querySelectorAll('[data-blog-post-insert]')
    );

    if (!sidebar || !inserts.length) {
      return null;
    }

    // Remember each insert's original inline position with a comment marker.
    var items = inserts.map(function (insert) {
      var marker = document.createComment('blog-post-insert');
      insert.before(marker);
      return { insert: insert, marker: marker };
    });

    var desktop = window.matchMedia('(min-width: 990px)');

    function apply() {
      if (desktop.matches) {
        items.forEach(function (item) {
          sidebar.appendChild(item.insert);
        });
        container.setAttribute('data-blog-post-inserts-placement', 'sidebar');
      } else {
        items.forEach(function (item) {
          item.marker.after(item.insert);
        });
        container.setAttribute('data-blog-post-inserts-placement', 'inline');
      }
    }

    apply();

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', apply);
    } else if (typeof desktop.addListener === 'function') {
      desktop.addListener(apply);
    }

    return apply;
  }

  function init() {
    var containers = document.querySelectorAll('[data-blog-post-inserts]');
    Array.prototype.forEach.call(containers, setupContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
